import { createPortal } from "react-dom";
import { AnimatePresence, motion } from "framer-motion";
import Calendar from "../Calendar";

// Portals the Calendar to document.body at a position computed by
// useCalendarDropdown, so it renders above any ancestor's overflow/scroll
// clipping and can be positioned/clamped independently of the trigger's
// own layout column.
//
// Must be rendered unconditionally by the caller (pass isOpen, don't wrap
// this component itself in `isOpen && <CalendarPopover .../>`) — AnimatePresence
// needs to stay mounted across the isOpen flip to play the exit animation
// before actually unmounting.
const CalendarPopover = ({
  isOpen,
  calendarRef,
  position,
  value,
  onChange,
  minDate,
  maxDate,
}) =>
  createPortal(
    <AnimatePresence>
      {isOpen && (
        <motion.div
          ref={calendarRef}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 8 }}
          transition={{ duration: 0.15 }}
          style={{
            position: "fixed",
            top: position.top,
            left: position.left,
            zIndex: 9999,
          }}
          className="bg-white rounded-xl shadow-xl border border-silver-light overflow-hidden"
        >
          <Calendar
            value={value}
            onChange={onChange}
            minDate={minDate}
            maxDate={maxDate}
          />
        </motion.div>
      )}
    </AnimatePresence>,
    document.body,
  );

export default CalendarPopover;
